import { render, staticRenderFns } from "./WaitingForArrival.vue?vue&type=template&id=510c0d53&scoped=true&"
import script from "./WaitingForArrival.vue?vue&type=script&lang=js&"
export * from "./WaitingForArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c0d53",
  null
  
)

export default component.exports